var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wbs-footer"},[_vm._v("WBSPacs-Manager - "+_vm._s(_vm.version)+"v")])}
var staticRenderFns = []

export { render, staticRenderFns }